<script lang="ts" setup>
import { Statistics } from '@/models/statistics.model';
import statisticsService from '@/services/statistics.service';

import { onMounted, ref } from 'vue';

const data = ref<Statistics[]>([]);
const data2 = ref<Statistics[]>([]);
const data3 = ref<Statistics[]>([]);

onMounted(async () => {
  const d = await statisticsService.usersPerDay();
  data.value = d;
  const d2 = await statisticsService.userInterests();
  data2.value = d2;
  const d3 = await statisticsService.userMotivation();
  data3.value = d3;
});
</script>
<template>
  <v-container>
    <h2>User signups per day</h2>
    <p>This shows the amount of new users each day for the last 30 days</p>
    <v-frappe-chart
      type="line"
      :labels="data.map((d) => d.label)"
      :data="[
        {
          name: data[0]?.stackedValues[0].label || '',
          values: data.map((d) => d.stackedValues[0].value),
        },
      ]"
      :height="300"
      :colors="['orange']"
    />
    <h2>User interests</h2>
    <p>This shows the amount of new users interested in each main category</p>
    <v-frappe-chart
      type="bar"
      :labels="data2.map((d) => d.label)"
      :data="[
        {
          name: data2[0]?.stackedValues[0].label || '',
          values: data2.map((d) => d.stackedValues[0].value),
        },
      ]"
      :height="300"
      :colors="['orange']"
    />
    <h2>User Motivation</h2>
    <p>This shows the amount of users per type of motivation</p>
    <v-frappe-chart
      type="bar"
      :labels="data3.map((d) => d.label)"
      :data="[
        {
          name: data3[0]?.stackedValues[0].label || '',
          values: data3.map((d) => d.stackedValues[0].value),
        },
      ]"
      :height="300"
      :colors="['orange']"
    />
  </v-container>
</template>
